import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { ATTR } from "../pages/CollectionPage";

export default function ContentCard({ item, kind, attrs }) {
  const { lang, t } = useApp();
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;
  return (
    <Link to={`/${kind}/${item.slug}`} className="content-card glass-card" data-testid={`content-card-${item.slug}`}>
      <div className="content-card-img-wrap">
        <img src={item.hero_image} alt={item[`title_${lang}`]} className="content-card-img" loading="lazy" />
        <span className="content-card-tag">{item[`subtitle_${lang}`]}</span>
      </div>
      <div className="content-card-body">
        <h3 className="content-card-title">{item[`title_${lang}`]}</h3>
        <p className="content-card-summary">{item[`summary_${lang}`]}</p>
        {attrs && (
          <div className="attr-row" data-testid={`attrs-${item.slug}`}>
            {Object.entries(attrs).map(([k, v]) => ATTR[k]?.[v] && (
              <span key={k} className={`attr-chip attr-${k}`}>{ATTR[k][v][lang]}</span>
            ))}
          </div>
        )}
        <span className="content-card-cta">
          {t("content.readMore")} <Arrow size={14} />
        </span>
      </div>
    </Link>
  );
}
